var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4,14.2c-0.4,1.2-1.9,1.8-3,1.7c-1.5-0.1-3.1-0.9-4.3-1.8 c-1.8-1.3-3.5-3.2-4.4-5.3C4,7.3,3.9,5.5,4.9,4.1c0.4-0.5,0.8-0.8,1.4-0.8c0.9,0,1,0.4,1.3,1.2c0.2,0.6,0.5,1.2,0.7,1.7 c0.3,1.1-0.8,1.2-0.9,2.1C7.3,8.9,8,9.7,8.3,10.1c0.6,0.8,1.3,1.5,2.2,2c0.5,0.3,1.2,0.8,1.8,0.5c0.8-0.5,0.8-1.9,1.9-1.4 c0.6,0.2,1.2,0.6,1.8,0.9C16.8,12.6,16.8,13.1,16.4,14.2C16.2,14.9,16.7,13.4,16.4,14.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCall);
export default __webpack_public_path__ + "static/media/ico-call.4621b035ffa01588d029184d11d75dcb.svg";
export { ForwardRef as ReactComponent };